<template>
    <!--  Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <MisteryBoxViewOne :data-set="dataSet" @update-info="getActivityInfo" />
    </div>
    <!--  Theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <MisteryBoxViewTwo :data-set="dataSet" @close="close" @open="open" @update-info="getActivityInfo" />
    </div>

    <!--  Theme three -->
    <div v-if="themeStore.themeIndex === 3">
        <MisteryBoxViewThree :data-set="dataSet" @update-info="getActivityInfo" />
    </div>

    <!--  Theme four -->
    <div v-if="themeStore.themeIndex === 4">
        <MisteryBoxViewFour :data-set="dataSet" @close="close" @open="open" @update-info="getActivityInfo" />
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useThemeStore } from '@/stores/theme';
import MisteryBoxViewOne from '@/themes/themeOne/misteryBox/misteryBoxView.vue';
import MisteryBoxViewTwo from '@/themes/themeTwo/misteryBox/misteryBoxView.vue';
import MisteryBoxViewThree from '@/themes/themeThree/misteryBox/misteryBoxView.vue';
import MisteryBoxViewFour from '@/themes/themeFour/misteryBox/misteryBoxView.vue';
import { getActivityInformations } from '@/api/common';

const themeStore = useThemeStore()
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const show = ref(false)
const depositButtonConfig = ref<any>({})
const mysteryRewardButtonConfig = ref<any>({})
const nonDepositButtonConfig = ref<any>({})
const todayDepositButtonConfig = ref<any>({})
const totalClaimedAmount = ref<number | string>(0)
const totalPrizeAmount = ref<number | string>(0)
    const isEmptyList = ref<boolean>(false)
const dataSet = computed<any>(() => ({
    show: show.value,
    depositButtonConfig: depositButtonConfig.value,
    mysteryRewardButtonConfig: mysteryRewardButtonConfig.value,
    nonDepositButtonConfig: nonDepositButtonConfig.value,
    todayDepositButtonConfig: todayDepositButtonConfig.value,
    totalClaimedAmount: totalClaimedAmount.value,
    totalPrizeAmount: totalPrizeAmount.value,
    isEmptyList: isEmptyList.value
}))
const emits = defineEmits(['handleClose'])
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const open = () => {
    show.value = true
    getActivityInfo()
}
const close = () => {
    show.value = false
    emits('handleClose')
}
const getActivityInfo = () => {
    loadingRef.value.open();
    let data = {
        activityId: "mystery_box"
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close();
        const tempObj = res.data;
        depositButtonConfig.value = tempObj.config.depositButton;
        mysteryRewardButtonConfig.value = tempObj.config.mysteryRewardButton;
        nonDepositButtonConfig.value = tempObj.config.nonDepositButton;
        todayDepositButtonConfig.value = tempObj.config.todayDepositButton;
        totalClaimedAmount.value = tempObj.config.totalClaimedAmount || 0;
        totalPrizeAmount.value = tempObj.config.totalPrizeAmount || 0;

        isEmptyList.value = !(depositButtonConfig.value && (depositButtonConfig.value?.available || depositButtonConfig.value?.alreadyClaimed))
            && !(mysteryRewardButtonConfig.value && (mysteryRewardButtonConfig.value?.available || mysteryRewardButtonConfig.value?.alreadyClaimed))
            && !(nonDepositButtonConfig.value && (nonDepositButtonConfig.value?.available || nonDepositButtonConfig.value?.alreadyClaimed))
            && !(todayDepositButtonConfig.value && (todayDepositButtonConfig.value?.available || todayDepositButtonConfig.value?.alreadyClaimed))
    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

defineExpose({
    open
})
onMounted(() => {
    if (themeStore.themeIndex === 1 || themeStore.themeIndex === 3) {
        getActivityInfo()
    }
})
</script>